import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AangifteRapport} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup} from "@angular/forms";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {BehaviorSubject} from "rxjs";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-overige-pga',
  templateUrl: './spec-overige-pga.component.html',
  styleUrls: ['./spec-overige-pga.component.scss'],
  imports: [SharedUiFormControlsModule, SharedUiDetailsModule, CommonModule, SharedUiButtonModule, SharedUiDialogModule],
})
export class SpecOverigePgaComponent implements OnChanges {

  @Input() public id!: string;
  @Input({required: true}) public rapport!: AangifteRapport;
  public dataVisible$ = new BehaviorSubject<boolean>(false);
  public dialogVisible = false;

  formGroup = new FormGroup({
    aftrekPerVerzorgingsdagWeekenduitgaven: new FormControl<number | null>(0),
    aftrekReiskostenWeekenduitgaven: new FormControl<number | null>(0),
    vergoedingWeekenduitgaven: new FormControl<number | null>(0),
    totaalAftrekbareWeekenduitgaven: new FormControl<number | null>(0),
    totaleWeekenduitgaven: new FormControl<number | null>(0),
    aandeelWeekenduitgaven: new FormControl<number | null>(0),
    totaalAftrekbareAlimentatie: new FormControl<number | null>(0),
    aandeelAftrekbareAlimentatie: new FormControl<number | null>(0),
    totaalRestantPga: new FormControl<number | null>(0),
    aandeelRestantPga: new FormControl<number | null>(0),
    nietToegerekendePga: new FormControl<number | null>(0),
  });

  propertyNamesToCheck: string[] = [
    'aftrekPerVerzorgingsdagWeekenduitgaven',
    'aftrekReiskostenWeekenduitgaven',
    'vergoedingWeekenduitgaven',
    'totaalAftrekbareWeekenduitgaven',
    'totaleWeekenduitgaven',
    'aandeelWeekenduitgaven',
    'totaalAftrekbareAlimentatie',
    'aandeelAftrekbareAlimentatie',
    'totaalRestantPga',
    'aandeelRestantPga',
    'nietToegerekendePga',
  ];

  propertyTextMap: Record<string, string> = {
    aftrekPerVerzorgingsdagWeekenduitgaven: 'Aftrek per verzorgingsdag weekenduitgaven',
    aftrekReiskostenWeekenduitgaven: 'Aftrek reiskosten weekenduitgaven',
    vergoedingWeekenduitgaven: 'Vergoeding weekenduitgaven',
    totaalAftrekbareWeekenduitgaven: 'Totaal aftrekbare weekenduitgaven',
    totaleWeekenduitgaven: 'Aftrek voor tijdelijk verblijf thuis van ernstig gehandicapten',
    aandeelWeekenduitgaven: 'Aftrek voor tijdelijk verblijf thuis van ernstig gehandicapten',
    totaalAftrekbareAlimentatie: 'Totaal aftrekbare alimentatie',
    aandeelAftrekbareAlimentatie: 'Onderhoudsverplichtingen',
    totaalRestantPga: 'Totaal restant persoongsbenonden aftrek',
    aandeelRestantPga: 'Restant persoonsgebonden aftrek voorgaande jaren',
    nietToegerekendePga: 'Niet toegerekende pga',
  };

  getPropertyValue(propertyName: string): number | null {
    const control = this.formGroup.get(['specificatieOverigePGA', 'opbouw', propertyName]);
    return control ? control.value : null;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['rapport'] && this.rapport) {
      this.dataVisible$.next(false);
      this.formGroup.reset({}, {emitEvent: false});
      this.formGroup.patchValue(this.rapport.specificatieOverigePGA?.opbouw || {}, {emitEvent: false});
      this.formGroup.disable();
      this.dataVisible$.next(true);
    }
  }

  showDialog() {
    this.dialogVisible = true;
  }
}
